import styled from '@emotion/styled'
interface Props {
  bgcolor?: string
  colorp?: string
  colorh2?: string
}
export const BoxStyle = styled.div<Props>`
  width: 260px;
  height: 130px;
  background: ${(props) => props.bgcolor};
  box-shadow: 5px 10px 22px 5px #8c8c8c;
  border-radius: 10px;
  line-height: 1;
  padding: 30px;
  flex-direction: column;
  display: flex;
  color: ${(props) => props.color};
`
export const H2Style = styled.span<Props>`
  color: ${(props) => props.colorh2};
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 15px;
  font-family: system-ui;
  letter-spacing: 0px;
`
export const PStyle = styled.span<Props>`
  color: ${(props) => props.colorp};
  font-size: 56px;
  font-weight: 600;
`
export const Box = ({
  bgcolor,
  colorp,
  colorh2,
  title,
  content,
}: {
  bgcolor: string

  colorh2: string
  colorp: string
  title: string
  content: string
}) => {
  return (
    <BoxStyle bgcolor={bgcolor}>
      <H2Style colorh2={colorh2}>{title}</H2Style>
      <PStyle colorp={colorp}>{content}</PStyle>
    </BoxStyle>
  )
}

export const MenuItem = styled.div`
  padding: 26px 0 26px 40px;
  text-align: left;
  font-size: 22px;
  border-bottom: 1px solid #707070;
  line-height: 2px;
`
